









import { Component, Vue } from "vue-property-decorator";

import NavBar from "@/components/menu/NavBar.vue";

@Component({
  components: {
    NavBar,
  },
})
export default class Settings extends Vue {
  links = {
    general: "General",
    icons: "Icon Styles",
    normal: "Normal",
    kh1: "KH1",
    important: "Important Checks Mode",
  };
}
